import { PaytrieAPI } from '@paytrie/client'
import type { StatusTone } from '@/components/StatusBadge'

const { TransactionStatus } = PaytrieAPI

const STATUS_LABELS: Record<
  NonNullable<PaytrieAPI.TransactionStatus>,
  string
> = {
  [TransactionStatus.complete]: 'Completed',
  [TransactionStatus.cancelled]: 'Cancelled',
  [TransactionStatus.expired]: 'Expired',
  [TransactionStatus['expired-contact-support']]: 'Expired',
  [TransactionStatus.refunded]: 'Refunded',
  [TransactionStatus.replaced]: 'Replaced',
  [TransactionStatus['awaiting-fiat']]: 'Waiting',
  [TransactionStatus['awaiting-crypto']]: 'Waiting',
  [TransactionStatus['processing-fiat']]: 'Processing',
  [TransactionStatus['finalizing-fiat']]: 'Processing',
  [TransactionStatus['sending-crypto']]: 'Sending Funds',
  [TransactionStatus['sending-fiat']]: 'Sending Funds',
}

const STATUS_TONES: Record<
  NonNullable<PaytrieAPI.TransactionStatus>,
  StatusTone
> = {
  [TransactionStatus.complete]: 'success',
  [TransactionStatus.cancelled]: 'failed',
  [TransactionStatus.expired]: 'failed',
  [TransactionStatus['expired-contact-support']]: 'failed',
  [TransactionStatus.refunded]: 'failed',
  [TransactionStatus.replaced]: 'pending',
  [TransactionStatus['awaiting-fiat']]: 'pending',
  [TransactionStatus['awaiting-crypto']]: 'pending',
  [TransactionStatus['processing-fiat']]: 'pending',
  [TransactionStatus['finalizing-fiat']]: 'pending',
  [TransactionStatus['sending-crypto']]: 'pending',
  [TransactionStatus['sending-fiat']]: 'pending',
}

export const CANCELLABLE_STATUSES: NonNullable<PaytrieAPI.TransactionStatus>[] =
  [TransactionStatus['awaiting-fiat'], TransactionStatus['awaiting-crypto']]

export const getStatusTone = (
  status: PaytrieAPI.TransactionStatus
): StatusTone => (status ? STATUS_TONES[status] : 'pending')

export const getStatusText = (status: PaytrieAPI.TransactionStatus): string =>
  status ? STATUS_LABELS[status] : ''
